"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author arsen.avagumyan on 1/15/2018.
 */
var IndicatorRuleCategory = /** @class */ (function () {
    function IndicatorRuleCategory(dbId, type, id, name) {
        this.dbId = dbId;
        this.type = type;
        this.id = id;
        this.name = name;
    }
    return IndicatorRuleCategory;
}());
exports.IndicatorRuleCategory = IndicatorRuleCategory;
// export class CategoryCache {
// 	private static cache: Array<IndicatorRuleCategory> = [];
//
// 	public static newCategory(dbId: number, type: string, id: string, name: string): IndicatorRuleCategory {
// 		for (let categoryByCache of this.cache) {
// 			if (categoryByCache.type == type && categoryByCache.id == type && categoryByCache.id == type) {
// 				if (!categoryByCache.dbId && dbId) {//TODO Arsen dbId and name
// 					categoryByCache.dbId = dbId;
// 				}
// 				if (!categoryByCache.name && name) {
// 					categoryByCache.name = name;
// 				}
// 				return categoryByCache;
// 			}
// 		}
// 		let category: IndicatorRuleCategory = new IndicatorRuleCategory(dbId, type, id, name);
// 		this.cache.push(category);
// 		return category
// 	}
// }
//# sourceMappingURL=indicator-rule-category.model.js.map